<template>
  <section data-test="filter-problem-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="problem-dimension">มิติที่ประสบปัญหา</label>
      <v-select
        data-test="problem-dimension"
        id="problem-dimension"
        v-model="dimensionComputed"
        :options="dimensionList"
        :clearable="true"
        placeholder="กรุณาเลือก"
        :appendToBody="true"
        @update:modelValue="dimensionSelected"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบข้อมูล
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="problem-select">ปัญหาความเดือดร้อน</label>
      <v-select
        data-test="problem-select"
        id="problem-select"
        v-model="problemComputed"
        :options="dataProblemList"
        :clearable="true"
        placeholder="กรุณาเลือก"
        :appendToBody="true"
        label="prob_des"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            กรุณาเลือกมิติที่ประสบปัญหา
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
  </section>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import problemData from "@/data/dim_prob.json"

const props = defineProps({
  dimension: String,
  problem: Object,
  listOptions: Array,
  headerTitle: {type: String, default: "ปัญหาความเดือดร้อน"}
});
const emits = defineEmits(["update:dimension", "update:problem"]);

const store = useStore();
const dimensionList = reactive([
  "มิติการเข้าถึงบริการรัฐ",
  "มิติการศึกษา",
  "มิติความเป็นอยู่",
  "มิติสุขภาพ",
  "มิติรายได้"
])
const dataProblemList = ref([])

const dimensionComputed = computed({
  get() {
    return props.dimension;
  },
  set(evt) {
    emits("update:dimension", evt);
  },
});
const problemComputed = computed({
  get() {
    return props.problem;
  },
  set(evt) {
    emits("update:problem", evt);
  },
});
const getProblemList = (opt)=>{
  dataProblemList.value = problemData.filter(item => item.dim_des == opt)
}
//when dimension change get problem list option if null empty problem list opt.
watch(dimensionComputed, (val) => {
  if (val) getProblemList(val);
  else dataProblemList.value = [];
});
const dimensionSelected = () =>{
  problemComputed.value = null
}

</script>
